import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HeaderComponent } from './header.component'
import { MobileMenuComponent } from './mobile-menu/mobile-menu.component'
import { ToggleMenuComponent } from './toggle-menu/toggle-menu.component'
import { DesktopMenuComponent } from './desktop-menu/desktop-menu.component'
import { MenuComponent } from './menu/menu.component'
import { AnchorService, LocalDeviceDetectorService } from 'dmmp-services'
import { SharedModule } from '../shared/shared.module'

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [HeaderComponent, MobileMenuComponent, ToggleMenuComponent, DesktopMenuComponent, MenuComponent],
  exports: [HeaderComponent],
  providers: [AnchorService, LocalDeviceDetectorService],
})
export class HeaderModule {
}
